import '.d{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ah{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.eb{background:var(--palette-white);}.ssr-plugin'
import '.ac{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.al{max-width:77.5rem;}.ssr-plugin'
import '.gl{justify-content:stretch;}.ssr-plugin'
import '.be{position:sticky;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.bx{z-index:10;}.ssr-plugin'
import '.g7{padding-block:1rem;}.ssr-plugin'
import '.g8{height:3rem;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.ar{flex-wrap:wrap;}.ssr-plugin'
import '.gn{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fr{margin-top:2rem;}.ssr-plugin'
import '.gd{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const CreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="d r ah e eb"
      >
        <div className="ac d t ah e"
        >
          <div className="n al d e gl be bf bx"
            style={{
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            <nav className="g7 g8 d ao t ar"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gn d e r fr gd n al"
            style={{
              gap: gap, // 8rem is padding + navbar height
              paddingInline: isMobile ? '2rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
